var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.108,
    height: 38.11,
    viewBox: "0 0 38.108 38.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 38.108,
    height: 38.11,
    fill: "#2e90d8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-1467 -8072.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(1467 8072.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34314",
    "data-name": "Path 34314",
    d: "M38.108,4.986V33.12a2.173,2.173,0,0,0-.07.245A5.56,5.56,0,0,1,32.452,38.1q-13.395.011-26.789-.01a6.015,6.015,0,0,1-1.858-.3A5.522,5.522,0,0,1,0,32.372q0-13.32,0-26.64c0-.124,0-.248.007-.372A5.433,5.433,0,0,1,3.125.6,12.113,12.113,0,0,1,4.987,0H33.121a1.483,1.483,0,0,0,.209.066,5.424,5.424,0,0,1,4.251,3.2,12.219,12.219,0,0,1,.526,1.722M2.233,19.014q0,6.679,0,13.359a3.352,3.352,0,0,0,3.487,3.5q13.34.008,26.68,0a3.345,3.345,0,0,0,3.47-3.477q.009-13.34,0-26.68A3.345,3.345,0,0,0,32.4,2.235q-13.358-.01-26.717.012a3.744,3.744,0,0,0-1.539.342A3.249,3.249,0,0,0,2.234,5.768q-.005,6.623,0,13.247",
    transform: "translate(0 0.001)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34315",
    "data-name": "Path 34315",
    d: "M106.72,96.622a10.046,10.046,0,1,1-10.092,9.991,10.08,10.08,0,0,1,10.092-9.991m-.045,17.86a7.814,7.814,0,1,0-7.815-7.813,7.839,7.839,0,0,0,7.815,7.813",
    transform: "translate(-87.62 -87.615)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34316",
    "data-name": "Path 34316",
    d: "M291.612,48.734a3.347,3.347,0,1,1-3.341,3.343,3.377,3.377,0,0,1,3.341-3.343m0,2.233a1.114,1.114,0,1,0,1.122,1.1,1.124,1.124,0,0,0-1.122-1.1",
    transform: "translate(-261.399 -44.191)",
    fill: "#2e90d8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.87532ea787b7a9d316968ab33c922560.svg";
export { ForwardRef as ReactComponent };